<template>
  <div>
    <div class="fruit_banner">
      <div class="fruit_banner_inner">
        <div class="fruit_banner_title">门店外卖相关功能开发</div>
        <div class="fruit_banner_sub">可根据客户需求承接门店外卖及微信端相关功能开发</div>
      </div>
    </div>
    <div class="delivery">
      <div class="deliver_img_parent">
        <img class="fruit_product_img" src="../../static/other/手机端商品SKU.png"/>
      </div>
      <div class="deliver_parent">
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[0].img"/>
          </div>
          <div class="delivery_border_title">{{delivery[0].title}}</div>
          <div class="delivery_border_content">{{delivery[0].contents[0]}}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[1].img"/>
          </div>
          <div class="delivery_border_title">{{delivery[1].title}}</div>
          <div class="delivery_border_content">{{delivery[1].contents[0]}}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[2].img"/>
          </div>
          <div class="delivery_border_title">{{delivery[2].title}}</div>
          <div class="delivery_border_content">{{delivery[2].contents[0]}}</div>
        </div>
      </div>
    </div>
    <!--<div>水果</div>-->

  </div>
</template>
<script>
    export default {
        name: 'Fruit',
        data () {
            return {
               delivery:[
                   {
                       img: require('../assets/other/定位图标.png'),
                       title: "配送范围配置相关开发",
                       contents:["商家后台配送范围配置相关功能开发"]
                   },{
                       img: require('../assets/other/骑车送.png'),
                       title: "配送方式配置相关开发",
                       contents:["配送方式配置相关功能开发"]
                   },{
                       img: require('../assets/other/券.png'),
                       title: "优惠券配置相关开发",
                       contents:["线上优惠券配置相关功能开发"]
                   }
               ]
            }
        }
    }
</script>

<style scoped>
  *{
    box-sizing: border-box;
    margin:0;
    padding:0;
  }
  .delivery_border{
    height: auto;
    margin: 20px;
    width: 55%;
    /*border-radius: 6px;*/
    /*border: 1px solid #EBEEF5;*/
  }
  .delivery_border_img{
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }
  .delivery_border_title{
    margin-top: 10px;
    font-size: 1.25em;
    font-weight: normal;
  }
  .delivery_border_content{
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: normal;
  }
  .fruit_banner{
    height: 550px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1f6b45 0%, #3f9d6d 55%, #7cb342 100%);
  }
  .fruit_banner_inner{
    text-align: center;
    color: #ffffff;
    padding: 0 20px;
  }
  .fruit_banner_title{
    font-size: 2.5em;
    font-weight: bold;
    letter-spacing: 2px;
  }
  .fruit_banner_sub{
    margin-top: 20px;
    font-size: 1.375em;
    font-weight: normal;
  }
  .fruit_product_img{
    width: 260px;
    height: auto;
  }
  .deliver_parent{
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .deliver_img_parent{
    width: 30%;
    height: auto;
  }
  .delivery{
    display: flex;
    height: 550px;
    width: 90%;
    margin: auto;
    justify-content: center;
    align-items: center;
  }
  /* 屏幕设备适配 max-device-width: 400px */
  @media screen and (max-device-width: 415px){
    .fruit_banner{
      height: 250px;
      width: 100%;
    }
    .fruit_banner_title{
      font-size: 1.625em;
    }
    .fruit_banner_sub{
      margin-top: 12px;
      font-size: 1em;
    }
    .fruit_product_img{
      width: 240px;
      height: auto;
    }
    .delivery_border_img{
      margin-top: 20px;
      width: 70px;
      height: 70px;
    }
    .deliver_img_parent{
      width: 100%;
      float: left;
      height: auto;
    }
    .deliver_parent{
      float: left;
      margin-top: 5px;
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .delivery_border{
      height: auto;
      margin:10px 0 auto;
      width: 100%;
      float: right;
      border-radius: 6px;
      border: 1px solid #EBEEF5;
    }
    .delivery{
      display: flex;
      width: 90%;
      height: auto;
      margin: auto;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .delivery_border_title{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
    }
    .delivery_border_content{
      margin-top: 5px;
      font-size: 1.125em;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }
</style>
